export default {
  title: 'Produse de print personalizate',
  fields: {
    name: 'Nume',
    format: 'Tip produs',
  },
  buttons: {
    upload_product: 'Pornește procesul de încărcare',
    preview: 'Previzualizare',
    edit: 'Editează',
  },
};
